<template>
<div>
  <div class="pm-search-input">
    <input class="e-input" type="text" :placeholder='$t("Pm.searchByName")' v-model="searchString" maxlength="255"/>
  </div>

  <div class="h-scroll h100-80">
    <div class="col-lg-12 control-section">
      <div class="h-topo-tree">
        <ejs-treeview ref='leftTree' :fields='searchFields' :nodeSelected='nodeSelected'></ejs-treeview>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'left',
  components: {},
  data() {
    return {
      searchString: '',
      initTree: [{ children: [] }],
      treeDatas: [{ children: [] }],
      responseDataArr: [],
      fields: {
        dataSource: this.treeDatas,
        id: 'id',
        text: 'text',
        child: 'children',
        isChecked: 'checked',
        iconCss: 'iconCls'
      },
      parentNodeInfo: [],
      nodeTimes: 0,
      isEnd: false,
      leafNodeID: '',
      oldSearchString:'',
    };
  },

  computed: {
    searchFields() {
      const This = this;
      const treeData = This.fields;
      const searchString = This.searchString.trim().toLowerCase();      

      if (!searchString) {
        if(this.oldSearchString !==''){
          this.oldSearchString = searchString;
          this.sendNodeEmit(this.leafNodeID);
        }
        return treeData;
      }
      
      this.oldSearchString = searchString;
      let selectedData = [];
      selectedData = This.responseDataArr.filter(item => (item.text.trim().toLowerCase().indexOf(searchString) !== -1));
      if (selectedData.length === 0) {
        selectedData = This.initTree;
      }

      return ({
        dataSource: selectedData,
        id: 'id',
        text: 'text',
        child: 'children',
        isChecked: 'checked',
        iconCss: 'iconCls'
      });
    }
  },

  methods: {
    ergodicTreeData(item) {
      const This = this;
      const { id, text, attributes, parentId, checked, selected} = item;
      const iconCls = (item.iconCls === 'icon-none') ? 'h-pm-iconNone' : 'icon hero-icon hero-icon-topo-frs h-pm-iconNe';// item.iconCss
      item.iconCls = iconCls;
      const data = {
        id,
        text,
        children: [],
        attributes,
        parentId,
        checked,
        selected,
        iconCls
      };

      This.responseDataArr.push(data);
      for (let item of item.children) {
        This.ergodicTreeData(item);
      }
    },
    nodeSelected(event) {
      this.sendNodeEmit(event.nodeData.id);
    },
    sendNodeEmit(nodeID) {
      let isLeafNode = false;
      const Text = {
        nodeText: '',
        nodePText: '',
        nodePPText: ''
      };

      if (nodeID === 'rootid') {
        this.$emit('nodeClicked', {
          nodeParam: {
            netypeid: '',
            measureobjecttypecode: '',
            countertypeid: '',
            neversionid: '',
            text: Text,
            isLeaf: isLeafNode
          } });
        return;
      }

      let selectedData = [];
      selectedData = this.responseDataArr.filter(item => (item.id.indexOf(nodeID) !== -1));

      if (selectedData.length === 0) {
        console.log('leftTree text error!!');
        return;
      }

      this.parentNodeInfo = [];
      this.setParentNodeInfo(selectedData[0]);
      const meterTimePeriod = this.getIntByBinary(selectedData[0].attributes.meterTimePeriod);

      for (let times = 0; times < this.parentNodeInfo.length; times++) {
        if (times === 0) {
          Text.nodeText = this.parentNodeInfo[times].text;
        } else if (times === 1) {
          Text.nodePText = this.parentNodeInfo[times].text;
        } else if (times === 2) {
          isLeafNode = true;
          Text.nodePPText = this.parentNodeInfo[times].text;
        }
      }

      // console.log('Text',isLeafNode,Text.nodeText,Text.nodePText,Text.nodePPText)
      this.$emit('nodeClicked', {
        nodeParam: {
          netypeid: selectedData[0].attributes.neTypeId !== undefined ? selectedData[0].attributes.neTypeId : '',
          measureobjecttypecode: selectedData[0].attributes.measureObjectTypeCode !== undefined ? selectedData[0].attributes.measureObjectTypeCode : '',
          countertypeid: selectedData[0].attributes.counterTypeId !== undefined ? selectedData[0].attributes.counterTypeId : '',
          neversionid: selectedData[0].attributes.neVersionId !== undefined ? selectedData[0].attributes.neVersionId : '',
          meterTimePeriod: meterTimePeriod,
          text: Text,
          isLeaf: isLeafNode
        } });
    },
    setParentNodeInfo(node) {
      if (node.id === 'rootid' || node.id === 'root') {
        return;
      }
      // console.log("node",node.text,node.id,node.parentId)
      this.parentNodeInfo.push(node);
      const parentNodeID = node.parentId;
      let selectedData = [];
      selectedData = this.responseDataArr.filter(item => (item.id.indexOf(parentNodeID) !== -1));

      if (selectedData.length > 0) {
        this.setParentNodeInfo(selectedData[0]);
      }
    },
    setLeafNodeSelectedState(item) {
      if (this.isEnd || item.children === undefined) {
        return;
      }

      if (item.children.length === 0) {
        if (this.nodeTimes === 3) {
          this.leafNodeID = item.id;
          item.selected = 'true';
          this.isEnd = true;
        } else if (this.nodeTimes === 2) {
          this.nodeTimes = 1;
        }

        return;
      }

      for (const item of item.children) {
        if (item.parentId === 'rootid') {
          this.nodeTimes = 0;
        }
        this.nodeTimes++;
        this.setLeafNodeSelectedState(item);
        if (item.selected === 'true') {
          break;
        }
      }
    },
    getIntByBinary(binary) {
      let result = 0, c = '', d = 0;
      const str = String(binary);
      if (str.length > 0) {
        for (let i = 0; i < str.length - 1; i++) {
          c = str.charAt(i);
          d = Number(c);
          result += d * Math.pow(2, str.length - 1 - i);
        }
        c = str.charAt(str.length - 1);
        d = Number(c);
        result += d;
      }
      return result;
    }
  },

  mounted() {
    const This = this;
    This.$axios.post('/lte/pm/indicator/indicatorTreeRoot.html').then(response => {
      if (response.status !== 200 || response.data === undefined) {
        return;
      }
      if (response.data.length > 0) {
        This.treeDatas = response.data;
        this.leafNodeID = '';
        this.nodeTimes = 0;
        this.setLeafNodeSelectedState(This.treeDatas[0]);

        This.responseDataArr = [];
        if (This.treeDatas.length > 0) {
          for (const item of This.treeDatas) {
            This.ergodicTreeData(item);
          }
        }

        This.fields = {
          dataSource: This.treeDatas,
          id: 'id',
          text: 'text',
          child: 'children',
          isChecked: 'checked',
          selected: 'selected',
          expanded: 'text',
          tooltip: 'text',
          iconCss: 'iconCls'
        };

        this.sendNodeEmit(this.leafNodeID);
      } else {
        console.log('error', response.data.errorCode);
      }
    }).catch((error) => { // 请求失败处理
      console.log('error', error);
    });
  }

};
</script>
